import _ from 'lodash';
import requireAll from 'javascripts/utils/requireAll';

const locales = requireAll(
  require.context('../../../../config/locales', true, /\.yml/)
);

const translations = Object.values(locales).reduce((accumulator, current) =>
  _.merge({}, accumulator, current)
);

export default (key, data) => {
  _.templateSettings.interpolate = /%{([\s\S]+?)}/g;

  const translationLocale = _.get(translations[locale], key) ? locale : 'en';

  if (!_.has(translations[translationLocale], key))
    throw `Missing translation: ${key}`;

  const compiled = _.template(
    _.get(translations[translationLocale], key),
    data
  );

  return compiled(data);
};
